import React from "react";

export default function SolarShieldUserLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M3 10.417c0-3.198 0-4.797.378-5.335c.377-.537 1.88-1.052 4.887-2.081l.573-.196C9.405 2.268 9.685 2 12 2s2.595.268 3.162.805l.573.196c3.007 1.029 4.51 1.544 4.887 2.081c.378.538.378 2.137.378 5.335v1.574c0 5.638-4.239 8.375-6.899 9.536c-.721.315-1.082.473-1.601.473s-.88-.158-1.601-.473C7.239 20.365 3 17.63 3 11.991z"></path>
        <circle cx={12} cy={9} r={2}></circle>
        <path strokeLinecap="round" d="M16 15c0-1.105-1.79-2-4-2s-4 .895-4 2"></path>
      </g>
    </svg>
  );
}
